const adminOverview = {
  actions: {
    retry: 'Retry',
  },
  activity: {
    empty: 'No recent app updates.',
    justNow: 'Just now',
    title: 'Recent activity',
  },
  description: 'Review key work across organization, applications, model gateway, and operations.',
  error: {
    description: 'Overview depends on several admin APIs. Check the network and try again.',
    title: 'Unable to load overview',
  },
  metrics: {
    activeKeys: {
      description: 'Currently enabled model distribution keys',
      label: 'Distribution keys',
    },
    activeMembers: {
      description: 'Member accounts that can access the user portal',
      label: 'Platform members',
    },
    activeModels: {
      description: 'Available to applications or {{hubAgentName}}',
      label: 'Enabled models',
    },
    pendingReview: {
      description: 'Application publishing items waiting for action',
      label: 'Review tasks',
    },
  },
  quickEntries: {
    apps: 'App list',
    departments: 'Departments',
    modelKeys: 'Model routing',
    modelProvider: 'Model registry',
    review: 'Publishing review',
    title: 'Quick access',
  },
  tasks: {
    branding: {
      detail: 'The site title affects login, sidebar branding, and browser title.',
      title: 'Complete branding',
    },
    coreAgent: {
      detail: 'When enabled, users can access {{hubAgentName}} from the user portal.',
      title: 'Enable {{hubAgentName}}',
    },
    count: '{{count}} open items',
    empty: 'No key items need attention.',
    expiringKeys: {
      detail: '{{count}} enabled keys expire within 14 days.',
      title: 'Rotate expiring distribution keys',
    },
    noKeys: {
      detail: 'Create a distribution key so downstream services can call the model gateway.',
      title: 'Create model distribution key',
    },
    noModels: {
      detail: 'Register and enable a model before applications or {{hubAgentName}} can select it.',
      title: 'Register an available model',
    },
    pendingReview: {
      detail: '{{count}} apps are waiting for the publishing workflow.',
      title: 'Review pending apps',
    },
    quotaRules: {
      detail: '{{count}} enabled quota rules are active and should be reviewed regularly.',
      title: 'Review distribution quotas',
    },
    sso: {
      detail: 'Configure SSO so members can sign in through the enterprise identity source.',
      title: 'Configure member authentication',
    },
    title: 'Open items',
  },
  title: 'Overview',
}

export default adminOverview
